export default __webpack_public_path__ + "static/media/measure4.9acce441.png";